import React, { Component } from "react";
import { Layout } from "antd";
import Filters from "./charts/Filters_images";
import ImagesTable from "./charts/Table_images";

const { Sider, Content } = Layout;

export default class Images extends Component {
  maxNumberOfRepetitions = this.props.data.sort(function (a, b) {
    return parseFloat(b.repetitions) - parseFloat(a.repetitions);
  })[0].repetitions;

  constructor(props) {
    super(props);
    this.state = {
      includedResolutions: ["High-res", "Mid-res", "Low-res"],
      includedFileTypes: ["svg", "png", "jpg", "gif"],
      repetitionsRange: [0, this.maxNumberOfRepetitions],
    };
  }

  changeIncludedResolutions = (value) => {
    this.setState({
      includedResolutions: value,
    });
  };

  changeIncludedFileTypes = (value) => {
    this.setState({
      includedFileTypes: value,
    });
  };

  changeRepetitionsRange = (value) => {
    this.setState({
      repetitionsRange: value,
    });
  };

  render() {
    const { includedResolutions } = this.state;
    const { includedFileTypes } = this.state;
    const { repetitionsRange } = this.state;
    const filteredData = this.props.data
      .filter(
        (article) => includedResolutions.indexOf(article.resolution) !== -1
      )
      .filter((article) => includedFileTypes.indexOf(article.file_type) !== -1)
      .filter(function (image) {
        var max = Math.max(...repetitionsRange);
        var min = Math.min(...repetitionsRange);
        return image.repetitions >= min && image.repetitions <= max;
      });

    return (
      <Layout>
        <Content
          className="viz-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignContent: "flex-start",
          }}
        >
          <ImagesTable
            data={filteredData}
            numberOfArticles={this.props.data.length}
          />
        </Content>
        <Sider theme="light">
          <Filters
            maxNumberOfRepetitions={this.maxNumberOfRepetitions}
            changeIncludedResolutions={this.changeIncludedResolutions}
            changeIncludedFileTypes={this.changeIncludedFileTypes}
            changeRepetitionsRange={this.changeRepetitionsRange}
          />
        </Sider>
      </Layout>
    );
  }
}
